import { useEffect, useState } from 'react';

/**
 * The search term after it has stopped changing for `delayMs`. The box and the URL take every
 * keystroke (D-25); only the argument sent to a query waits for a pause.
 */
export function useDebouncedQuery(q: string, delayMs = 300): string {
  const [settled, setSettled] = useState(q);

  useEffect(() => {
    if (q === settled) return;
    const timer = setTimeout(() => setSettled(q), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs, settled, q]);

  return settled;
}
